/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Platform_Step_Hours_BodyInputs */

const en_platform_step_hours_body = /** @type {(inputs: Platform_Step_Hours_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`When you work, what you offer and what it costs.`)
};

const pl_platform_step_hours_body = /** @type {(inputs: Platform_Step_Hours_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kiedy pracujesz, co oferujesz i ile to kosztuje.`)
};

/**
* | output |
* | --- |
* | "When you work, what you offer and what it costs." |
*
* @param {Platform_Step_Hours_BodyInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const platform_step_hours_body = /** @type {((inputs?: Platform_Step_Hours_BodyInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Platform_Step_Hours_BodyInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_platform_step_hours_body(inputs)
	return en_platform_step_hours_body(inputs)
});